import { render, staticRenderFns } from "./MerchantOrder.vue?vue&type=template&id=2f4e4308&"
import script from "./MerchantOrder.vue?vue&type=script&lang=js&"
export * from "./MerchantOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports